export default "__VITE_ASSET__bn1C_ln6__"